module.exports = __webpack_public_path__ + "img/jiaoxue.8909eb14.svg";